<template>
  <Menu buttonText="Register Here" />
  <main id="home">
    <hero />
    <hotel />
    <reservations />
    <speakers />
    <companypass />
    <sponsors />
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/menu';
import hero from '@/components/hero.vue';
import hotel from '@/components/hotel.vue';
import reservations from '@/components/reservations.vue';
import companypass from '@/components/companypass.vue';
import sponsors from '@/components/sponsors.vue';
import speakers from '@/components/speakers.vue';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    Menu,
    hero,
    hotel,
    reservations,
    sponsors,
    companypass,
    speakers
  },
};
</script>
